import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

export const UnauthorizedOverlay: React.FC = () => {
  const history = useHistory();

  // auto-redirect after 5 seconds
  useEffect(() => {
    const t = setTimeout(() => history.push('/'), 5000);
    return () => clearTimeout(t);
  }, [history]);

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-6'>
      <div className='bg-white rounded-xl shadow-xl p-8 max-w-sm text-center'>
        { /* Animated Shield Lock SVG */ }
        <svg
            className='mx-auto mb-4 w-24 h-24 animate-pulse text-green-600'
            fill='none'
            stroke='currentColor'
            strokeWidth={2}
            viewBox='0 0 24 24'
            xmlns='http://www.w3.org/2000/svg'
        >
          <path
              strokeLinecap='round'
              strokeLinejoin='round'
              d='M12 11c.628 0 1 .372 1 1v2h-2v-2c0-.628.372-1 1-1z'
          />
          <path
              strokeLinecap='round'
              strokeLinejoin='round'
              d='M12 2C8.134 2 5 4.686 5 8v4c0 3.314 3.134 6 7 6s7-2.686 7-6V8c0-3.314-3.134-6-7-6z'
          />
        </svg>

        <h2 className='text-2xl font-semibold mb-2'>Unauthorized</h2>
        <p className='mb-6 text-gray-600'>
          You don’t have permission to view this. Please contact your
          administrator.
        </p>
        <button
            onClick={() => history.push('/')}
            className='px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700'
        >
          Go Home Now
        </button>
      </div>
    </div>
  );
};
